<script setup lang="ts">
defineProps<{
    errors: string[];
}>();
</script>

<template>
    <ul
        v-if="errors.length"
        class="cart-errors"
        aria-live="assertive"
        aria-atomic="false"
    >
        <li v-for="(err, i) in errors" :key="i" class="alert alert-danger cart-errors__item">
            {{ err }}
        </li>
    </ul>
</template>
